import { Dayjs } from "dayjs";
import generatePicker from "antd/es/date-picker/generatePicker";
import dayjsGenerateConfig from "@rc-component/picker/es/generate/dayjs";
//import "antd/lib/date-picker/style"; // use less
// import "antd/lib/date-picker/style/css"; // use css
// import "antd/lib/date-picker/style/index.css"; // use css

const DatePicker = generatePicker<Dayjs>(dayjsGenerateConfig);

export default DatePicker;
 